if (!customElements.get('video-modal')) {
    customElements.define('video-modal', class VideoModal extends HTMLElement {
        constructor() {
            super();

            this.poster = this.querySelector('img');
            this.videoPlayBackground = this.dataset.playBackground;
            this.shareContainer = this.closest('div').querySelector('.video-share-wrapper');

            this.toFullscreen = this.toFullscreen.bind(this);

            this.addEventListener('click', this.toFullscreen);
        }

        toFullscreen() {
            const modalContainer = document.createElement('div');
            const videoContainer = document.createElement('div');
            const posterContainer = document.createElement('div');
            const controlsContainer = document.createElement('div');
            const shareContainer = document.createElement('div');
            const video = document.createElement('video');
            const videoSource = document.createElement('source');
            const imageSource = document.createElement('img');
            const posterClone = this.poster.cloneNode(true);
            const shareClone = this.shareContainer.cloneNode(true);
            const shareButton = document.createElement('button');
            const muteButton = document.createElement('button');
            const closeButton = document.createElement('button');

            modalContainer.classList.add('video-modal');
            videoContainer.classList.add('video-modal-video-wrapper');
            posterContainer.classList.add('video-modal-poster-wrapper');
            controlsContainer.classList.add('video-modal-controls-wrapper');
            shareContainer.classList.add('video-modal-share-wrapper');

            imageSource.src = this.dataset.imageSrc;
            videoSource.src = this.dataset.videoSrc;
            videoSource.type = this.dataset.videoType;

            video.setAttribute('playsinline', "playsinline");
            video.setAttribute('autoplay', 'autoplay');
            video.setAttribute('loop', 'loop');
            video.setAttribute('width', this.dataset.videoWidth);
            video.setAttribute('height', this.dataset.videoHeight);
            video.appendChild(videoSource);
            video.appendChild(imageSource);

            shareButton.id = 'video-modal-share';
            muteButton.id = 'video-modal-mute';
            muteButton.classList.add('show');
            closeButton.id = 'video-modal-close';

            shareButton.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="50" height="50" viewBox="0 0 50 50">
                    <path d="M 37 4.0039062 C 34.69525 4.0037812 32.389766 4.8822188 30.634766 6.6367188 L 25.634766 11.636719 C 23.142766 14.128719 22.430516 17.727281 23.478516 20.863281 L 27.070312 17.271484 C 27.220312 16.244484 27.673891 15.253844 28.462891 14.464844 L 33.462891 9.4648438 C 34.437891 8.4908438 35.72 8.0019531 37 8.0019531 C 38.28 8.0019531 39.561156 8.4898437 40.535156 9.4648438 C 42.484156 11.414844 42.484156 14.586156 40.535156 16.535156 L 35.535156 21.535156 C 34.746156 22.324156 33.756516 22.776734 32.728516 22.927734 L 29.134766 26.521484 C 30.062766 26.831484 31.029047 26.996094 31.998047 26.996094 C 34.303047 26.996094 36.608281 26.118281 38.363281 24.363281 L 43.363281 19.363281 C 46.873281 15.854281 46.872281 10.145719 43.363281 6.6367188 C 41.608281 4.8827187 39.30475 4.0040313 37 4.0039062 z M 30.960938 16.980469 A 2.0002 2.0002 0 0 0 29.585938 17.585938 L 17.585938 29.585938 A 2.0002 2.0002 0 1 0 20.414062 32.414062 L 32.414062 20.414062 A 2.0002 2.0002 0 0 0 30.960938 16.980469 z M 18.449219 23.023438 C 15.997141 22.898656 13.506469 23.765766 11.636719 25.634766 L 6.6367188 30.634766 C 3.1277188 34.143766 3.1277187 39.854281 6.6367188 43.363281 C 8.3917188 45.117281 10.696 45.994141 13 45.994141 C 15.304 45.994141 17.608281 45.116328 19.363281 43.361328 L 24.363281 38.361328 C 26.855281 35.869328 27.569484 32.270766 26.521484 29.134766 L 22.927734 32.728516 C 22.777734 33.755516 22.324156 34.746156 21.535156 35.535156 L 16.535156 40.535156 C 14.586156 42.485156 11.413844 42.485156 9.4648438 40.535156 C 7.5158438 38.585156 7.5158438 35.413844 9.4648438 33.464844 L 14.464844 28.464844 C 15.253844 27.675844 16.244484 27.221312 17.271484 27.070312 L 20.863281 23.478516 C 20.079281 23.216516 19.266578 23.065031 18.449219 23.023438 z"></path>
                </svg>
            `;

            muteButton.innerHTML = `
                <svg class="mute-icon" role="img" width="100%" height="100%" viewBox="0 0 40 40">
                    <title>Mute video audio</title>
                    <filter id="shadowFilter" color-interpolation-filters="sRGB">
                        <feDropShadow dx="0" dy="0" stdDeviation="1" flood-color="black" flood-opacity="0.35"></feDropShadow>
                    </filter>
                    <path class="mute-line" filter="url(#shadowFilter)" fill-rule="evenodd" clip-rule="evenodd" 
                        d="M10.9758 8.69506C10.5819 8.28271 9.92344 8.28271 9.52955 8.69506L9.13035 9.11296C8.76116 9.49945 8.76116 10.1079 9.13035 10.4944L28.106 30.3592C28.4999 30.7715 29.1583 30.7715 29.5522 30.3592L29.9514 29.9413C30.3206 29.5548 30.3206 28.9463 29.9514 28.5598L10.9758 8.69506Z" 
                        fill="currentColor">
                    </path>
                    <path filter="url(#shadowFilter)" fill-rule="evenodd" clip-rule="evenodd" d="M11.4867 24.5304H14.6623C14.7592 24.5304 14.8345 24.5643 14.9099 24.6321L19.8186 29.2438C20.3999 29.7863 20.8521 30.0463 21.4334 30.0463C22.273 30.0463 22.8974 29.3907 22.8974 28.5204V10.5824C22.8974 9.70079 22.273 9 21.4226 9C20.8413 9 20.443 9.27127 19.8186 9.84773L14.9099 14.4368C14.8345 14.5046 14.7592 14.5385 14.6623 14.5385H11.4867C9.83966 14.5385 9 15.4314 9 17.2738V21.7951C9 23.6375 9.83966 24.5304 11.4867 24.5304ZM11.6912 22.4393C11.3144 22.4393 11.1314 22.2472 11.1314 21.8516V17.2173C11.1314 16.8217 11.3144 16.6296 11.6912 16.6296H15.179C15.4466 16.6296 15.643 16.588 15.8563 16.4125L20.4215 12.0631C20.4753 12.0179 20.5399 11.9727 20.6045 11.9727C20.6906 11.9727 20.7659 12.0405 20.7659 12.1422V26.8927C20.7659 27.0058 20.7014 27.0736 20.6045 27.0736C20.5506 27.0736 20.4861 27.0397 20.4322 26.9832L15.9648 22.7445C15.7065 22.4958 15.4912 22.4393 15.179 22.4393H11.6912ZM27.1495 22.9706C26.7297 23.6488 26.8265 24.3269 27.3755 24.7112C27.8492 25.039 28.4736 24.926 28.8288 24.4174C29.7223 23.1514 30.2497 21.3542 30.2497 19.5118C30.2497 17.6581 29.7223 15.8836 28.8288 14.595C28.4736 14.0864 27.8492 13.9733 27.3755 14.3011C26.8265 14.6967 26.7189 15.3749 27.1602 16.0531C27.7523 16.9347 28.1075 18.2233 28.1075 19.5118C28.1075 20.8117 27.7415 22.0889 27.1495 22.9706Z" fill="currentColor">
                    </path>
                </svg>        
            `;

            closeButton.innerHTML = `
                <svg role="img" width="100%" height="100%" viewBox="0 0 40 40" aria-hidden="true" data-testid="video-controls-minimize-icon-caret-down"><title></title><filter id="shadowFilter" color-interpolation-filters="sRGB"><feDropShadow dx="0" dy="0" stdDeviation="1" flood-color="black" flood-opacity="0.35"></feDropShadow></filter><path filter="url(#shadowFilter)" fill-rule="evenodd" clip-rule="evenodd" d="M20 22.2779L27.6032 14.6746C28.1642 14.1137 29.0737 14.1137 29.6347 14.6746C30.1957 15.2356 30.1957 16.1452 29.6347 16.7062L21.0157 25.3251C20.4547 25.8861 19.5452 25.8861 18.9842 25.3251L10.3652 16.7062C9.80424 16.1452 9.80424 15.2356 10.3652 14.6746C10.9262 14.1137 11.8357 14.1137 12.3967 14.6746L20 22.2779Z" fill="white"></path></svg>
            `;

            controlsContainer.appendChild(shareButton);
            controlsContainer.appendChild(muteButton);
            controlsContainer.appendChild(closeButton);

            videoContainer.innerHTML = `
                <div id="video-modal-loading">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="35 35 30 30" width="58" height="58" preserveAspectRatio="xMidYMid" style="display:block;">
                        <circle stroke-dasharray="61.26105674500097 22.420352248333657" r="13" stroke-width="3" stroke="${this.videoPlayBackground}" fill="none" cy="50" cx="50" />
                    </svg>
                </div>
                <button id="video-modal-play">
                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="50" height="50" viewBox="0 0 512 512">
                        <path fill="${this.videoPlayBackground}" d="M504.1,256C504.1,119,393,7.9,256,7.9C119,7.9,7.9,119,7.9,256C7.9,393,119,504.1,256,504.1C393,504.1,504.1,393,504.1,256z"></path><path fill="#FFF" d="M378.7,243.2L203.8,135.7c-4.8-2.9-11.1-3.1-16-0.3c-5,2.8-8.1,8.1-8.1,13.8v214c0,5.7,3.1,11,8,13.8c2.4,1.3,5,2,7.7,2c2.9,0,5.7-0.8,8.2-2.3l174.9-106.6c4.7-2.8,7.6-8,7.6-13.4C386.3,251.2,383.4,246,378.7,243.2z"></path>
                    </svg>
                </button>
            `;

            shareClone.querySelectorAll('svg').forEach((svg) => {
                const gradients = svg.querySelectorAll('linearGradient, radialGradient');

                gradients.forEach(gradient => {
                    const newId = Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
                    const oldId = gradient.id;

                    gradient.id = newId;

                    const path = svg.querySelector(`path[fill="url(#${oldId})"]`);
                    if (path) {
                        path.setAttribute('fill', `url(#${newId})`);
                    }
                })
            });

            shareContainer.innerHTML = shareClone.innerHTML;

            videoContainer.appendChild(video);
            posterContainer.appendChild(posterClone);
            modalContainer.appendChild(videoContainer);
            modalContainer.appendChild(posterContainer);
            modalContainer.appendChild(controlsContainer);
            modalContainer.appendChild(shareContainer);
            document.body.appendChild(modalContainer);

            video.setAttribute('oncontextmenu', "return false;");
            videoContainer.classList.add('playing');
            video.play();

            video.addEventListener('load', () => {
                const loading = this.querySelector('#video-modal-loading');

                if (loading) loading.remove();
            });

            video.addEventListener('play', () => {
                const loading = this.querySelector('#video-modal-loading');
                if (loading) loading.remove();
                videoContainer.classList.add('playing');
            });

            video.addEventListener('pause', () => {
                videoContainer.classList.remove('playing');
            });

            videoContainer.addEventListener('click', (e) => {
                if (videoContainer.classList.contains('playing')) {
                    videoContainer.classList.remove('playing');
                    video.pause();
                } else {
                    videoContainer.classList.add('playing');
                    video.play();
                }
            });

            controlsContainer.querySelector('#video-modal-share').addEventListener('click', (e) => {
                if (shareContainer.classList.contains('show')) {
                    shareContainer.classList.remove('show');
                } else {
                    shareContainer.classList.add('show');
                }
            });

            closeButton.addEventListener('click', (e) => {
                modalContainer.remove();
            });

            muteButton.addEventListener('click', (e) => {
                if (muteButton.classList.contains('mute')) {
                    muteButton.classList.remove('mute');
                    video.muted = false;
                } else {
                    muteButton.classList.add('mute');
                    video.muted = true;
                }
            });

            shareContainer.querySelector('.share-button__close').addEventListener('click', (e) => {
                shareContainer.classList.remove('show');
            });

            shareContainer.querySelector('.share-button__button').addEventListener('click', (e) => {
                shareContainer.classList.remove('show');
            });

            shareContainer.querySelector('.video-share-copy').addEventListener('click', (e) => {
                shareContainer.classList.remove('show');

                navigator.clipboard.writeText(window.location.href)
                    .then(() => {
                        const urlCopiedContainer = document.createElement('div');
                        urlCopiedContainer.classList.add('video-modal-url-copied');
                        urlCopiedContainer.innerHTML = `Link Copied`;

                        modalContainer.appendChild(urlCopiedContainer);

                        setTimeout(() => {
                            urlCopiedContainer.remove();
                        }, 3000);
                    })
                    .catch((error) => {
                        console.error("Failed to copy URL:", error);
                    });
            });
        }
    });
}